import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DEFAULT_STORE_SLUG = "magere-viandes";

const StoreProtectedRoute = ({ children, storeSlug: propStoreSlug }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { storeSlug: paramStoreSlug } = useParams();
  const storeSlug = propStoreSlug || paramStoreSlug || DEFAULT_STORE_SLUG;
  const standalone = !!propStoreSlug || !paramStoreSlug;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8f9fb]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-400"></div>
      </div>
    );
  }

  if (!user) {
    const loginPath = standalone ? '/login' : `/store/${storeSlug}/login`;
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return children;
};

export default StoreProtectedRoute;
